module.exports = __webpack_public_path__ + "img/monitor.5f543b9d.png";